import { ScrollArea } from '@mantine/core';
import { GameButton } from './GameButton';
import classes from "../styles/GameButton.css"
import supabase from '../api/client';
import { useEffect, useState } from 'react';

export const RecentGames = ( { setQuery, setFilters }) => {
  const [games, setGames] = useState([])
  
  async function getRecentGames() {
    const { data:games } = await supabase.from("Game").select("*, Event (id, name), teamOne:teamOneId (id), teamTwo:teamTwoId (id)").order("date", { ascending: false }).range(0, 19)
    const ids = games.map((game) => game.id)
    const { data:clips } = await supabase.from("Highlight").select("gameId").in("gameId", ids)

    let counts = {}

    for (let id of ids) {
      counts[id] = 0
    }

    for (let clip of clips) {
      if (clip.gameId in counts)
        counts[clip.gameId] += 1
    }

    for (let game of games) {
      game["clip-count"] = counts[game.id]
    }

    setGames(games)
  }

  useEffect(() => {
    getRecentGames()
  }, [])

  return (
    <ScrollArea
      scrollbarSize={7}
      type="always"
      classNames={classes}
      scrollbars="x"
      styles={{
        root: {
          whiteSpace: "nowrap"
        }
      }}
    >
      {games.map((game, index) => {
        if (index === 0)
          return <GameButton key={game.id} setQuery={setQuery} setFilters={setFilters} game={game} pos={"left"} />
        else if (index === games.length - 1)
          return <GameButton key={game.id} setQuery={setQuery} setFilters={setFilters} game={game} pos={"right"} />
        
        return <GameButton key={game.id} setQuery={setQuery} setFilters={setFilters} game={game} />
      })}
    </ScrollArea>
  )
}
